import { useEffect } from 'react';

// Sets the browser-tab title, which Google also uses as the search-result
// headline. index.html holds the default until a page provides its own.
export function useDocumentTitle(title) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);
}
